/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import theme, { Content_Text } from "../Component/theme";

import image_parking_1 from "../image/image_parking_1.png";
import image_parking_2_1 from "../image/image_parking_2_1.png";
import image_parking_2_2 from "../image/image_parking_2_2.png";
import image_parking_3_1 from "../image/image_parking_3_1.png";
import image_parking_3_2 from "../image/image_parking_3_2.png";
import image_parking_4_1 from "../image/image_parking_4_1.png";
import image_parking_4_2 from "../image/image_parking_4_2.png";
import image_parking_5_1_1 from "../image/image_parking_5_1_1.png";
import image_parking_5_1_2 from "../image/image_parking_5_1_2.png";
import image_parking_5_1_3 from "../image/image_parking_5_1_3.png";
import image_parking_5_2_1 from "../image/image_parking_5_2_1.png";
import image_parking_5_2_2 from "../image/image_parking_5_2_2.png";
import image_parking_5_2_3 from "../image/image_parking_5_2_3.png";
import image_parking_5_2_4 from "../image/image_parking_5_2_4.png";
import image_parking_5_3_1 from "../image/image_parking_5_3_1.png";
import image_parking_5_3_2 from "../image/image_parking_5_3_2.png";
import image_parking_5_3_3 from "../image/image_parking_5_3_3.png";
import image_parking_6 from "../image/image_parking_6.png";

import img_Platform_1 from "../image/image_Platform_1.png";
import img_Platform_2 from "../image/image_Platform_2.png";
import img_Platform_2_sel from "../image/image_Platform_2_sel.png";
import img_Platform_3 from "../image/image_Platform_3.png";
import img_Platform_3_sel from "../image/image_Platform_3_sel.png";
import img_Platform_4 from "../image/image_Platform_4.png";
import img_Platform_4_sel from "../image/image_Platform_4_sel.png";
import img_Platform_5_sel from "../image/image_Platform_5_sel.png";
import img_Platform_6 from "../image/image_Platform_6.png";
import img_Platform_6_sel from "../image/image_Platform_6_sel.png";
import img_Platform_7 from "../image/image_Platform_7.png";
import img_Platform_7_sel from "../image/image_Platform_7_sel.png";
import img_Platform_9 from "../image/image_Platform_9.png";

const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 20px;
`;

const Select_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1100px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 1200px) {
    padding: 50px 15px 0px 15px;
    max-width: 650px;
  }
  @media (max-width: 800px) {
    padding: 0px;
    max-width: 650px;
  }
`;

const Btn_Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  text-align: center;
  @media (max-width: 800px) {
    flex: 0;
  }
`;

const Main_Bar = styled.div`
  border-width: 2px 0px 0px 0px;
  border-color: ${theme.colors.bgGray};
  border-style: solid;
  width: 1200px;
  margin-bottom: 30px;
  @media (max-width: 800px) {
    width: 100%;
  }
`;

const Title_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 5px;
`;
const Image_div2 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
const Text_div2 = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  text-align: center;
  margin-bottom: 100px;
`;

const Image3 = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: ${(props) => (props.$large ? "900px" : "800px")};
  margin-bottom: 30px;
  margin-left: ${(props) => (props.$large ? "100px" : 0)};
  border-radius: 8px;

  @media (max-width: 800px) {
    width: ${(props) => (props.$large ? "90%" : "80%")};
    margin-left: ${(props) => (props.$large ? "10%" : 0)};
  }
`;

const Image2 = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: 60px;
  cursor: pointer;
`;

const Main_Content3 = styled.div`
  width: 100%;
  max-width: 700px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;

const Parking5_div = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Parking5_Btn = styled.div`
  cursor: pointer;
  display: flex;
  border-style: solid;
  border-radius: 100px;
  border-width: 1px;
  border-color: ${(props) =>
    props.$select ? "#3D62AC" : theme.colors.barGray};
  align-items: center;
  justify-content: center;
  padding: 8px 20px;
  margin: 5px;
  margin-bottom: 50px;
  color: ${(props) => (props.$select ? "#3D62AC" : theme.colors.fontLightGray)};
`;

const Platform_FMS_주차시설 = () => {
  const [sel, set_Sel] = useState("01");
  const [parking5_type, set_Parking5_Type] = useState("공사원가계산서");

  return (
    <>
      <Main_div>
        <Select_div>
          <Main_Content3>
            <Btn_Div>
              <Image2
                onClick={() => {
                  set_Sel("01");
                }}
                src={sel === "01" ? img_Platform_2_sel : img_Platform_2}
                alt={img_Platform_1}
              />
              <Content_Text
                style={{ marginTop: 10 }}
                $blue2={sel === "01"}
                $lightGray
                $small
                $bold
              >
                기본현황
              </Content_Text>
            </Btn_Div>
            <Btn_Div>
              <Image2
                onClick={() => {
                  set_Sel("02");
                }}
                src={sel === "02" ? img_Platform_3_sel : img_Platform_3}
                alt={img_Platform_1}
              />
              <Content_Text
                style={{ marginTop: 10 }}
                $blue2={sel === "02"}
                $lightGray
                $small
                $bold
              >
                유지관리
              </Content_Text>
            </Btn_Div>
            <Btn_Div>
              <Image2
                onClick={() => {
                  set_Sel("03");
                }}
                src={sel === "03" ? img_Platform_4_sel : img_Platform_4}
                alt={img_Platform_1}
              />
              <Content_Text
                style={{ marginTop: 10 }}
                $blue2={sel === "03"}
                $lightGray
                $small
                $bold
              >
                장비현황관리
              </Content_Text>
            </Btn_Div>
            <Btn_Div>
              <Image2
                onClick={() => {
                  set_Sel("04");
                }}
                src={sel === "04" ? img_Platform_7_sel : img_Platform_7}
                alt={img_Platform_1}
              />
              <Content_Text
                style={{ marginTop: 10 }}
                $blue2={sel === "04"}
                $lightGray
                $small
                $bold
              >
                점검표
              </Content_Text>
            </Btn_Div>
            <Btn_Div>
              <Image2
                onClick={() => {
                  set_Sel("05");
                }}
                src={sel === "05" ? img_Platform_5_sel : img_Platform_9}
                alt={img_Platform_1}
              />
              <Content_Text
                style={{ marginTop: 10 }}
                $blue2={sel === "05"}
                $lightGray
                $small
                $bold
              >
                문서생성
              </Content_Text>
            </Btn_Div>
            <Btn_Div>
              <Image2
                onClick={() => {
                  set_Sel("06");
                }}
                src={sel === "06" ? img_Platform_6_sel : img_Platform_6}
                alt={img_Platform_1}
              />
              <Content_Text
                style={{ marginTop: 10 }}
                $blue2={sel === "06"}
                $lightGray
                $small
                $bold
              >
                보수비 및
              </Content_Text>
              <Content_Text $blue2={sel === "06"} $lightGray $small $bold>
                집행실적
              </Content_Text>
            </Btn_Div>
          </Main_Content3>
        </Select_div>
      </Main_div>
      <Main_div>
        <Main_Bar></Main_Bar>
      </Main_div>
      <Title_div>
        <Content_Text $bold $blue2>
          {sel}
        </Content_Text>
      </Title_div>
      <Title_div style={{ marginBottom: 30 }}>
        <Content_Text $xlarge $xbold>
          {sel === "01"
            ? "기본현황"
            : sel === "02"
            ? "유지관리"
            : sel === "03"
            ? "장비현황관리"
            : sel === "04"
            ? "점검표"
            : sel === "05"
            ? "문서생성"
            : "일정"}
        </Content_Text>
      </Title_div>
      {sel === "01" ? (
        <>
          <Image_div2>
            <Image3 src={image_parking_1} alt={image_parking_1} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              모니터링
            </Content_Text>
            <Content_Text $gray>
              등록한 시설들의 상세내용을 모니터링 할 수 있습니다.
            </Content_Text>
          </Text_div2>
        </>
      ) : sel === "02" ? (
        <>
          <Image_div2>
            <Image3 src={image_parking_2_1} alt={image_parking_2_1} />
          </Image_div2>
          <Image_div2>
            <Image3 src={image_parking_2_2} alt={image_parking_2_2} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              유지관리 접수/이행
            </Content_Text>
            <Content_Text $gray>
              관리가 필요한 주차장을 등록하고 유지관리에 필요한 정보를 입력할 수
              있습니다.
            </Content_Text>
          </Text_div2>
        </>
      ) : sel === "03" ? (
        <>
          <Image_div2>
            <Image3 src={image_parking_3_1} alt={image_parking_3_1} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              장비등록
            </Content_Text>
            <Content_Text $gray>
              주차장 유지보수에 필요한 장비들을 등록하고 관리할 수 있습니다.
            </Content_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={image_parking_3_2} alt={image_parking_3_2} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              소모품 교체
            </Content_Text>
            <Content_Text $gray>
              등록한 장비들의 교체주기를 확인할 수 있으며 상세정보를 볼 수
              있습니다.
            </Content_Text>
          </Text_div2>
        </>
      ) : sel === "04" ? (
        <>
          <Image_div2>
            <Image3 src={image_parking_4_1} alt={image_parking_4_1} />
          </Image_div2>
          <Image_div2>
            <Image3 src={image_parking_4_2} alt={image_parking_4_2} />
          </Image_div2>
          <Text_div2>
            <Content_Text $gray>
              주차장의 시설물들을 점검표로 일일점검을 할 수 있습니다.
            </Content_Text>
          </Text_div2>
        </>
      ) : sel === "05" ? (
        <>
          <Parking5_div>
            <Parking5_Btn
              onClick={() => {
                set_Parking5_Type("공사원가계산서");
              }}
              $select={parking5_type === "공사원가계산서"}
            >
              공사원가계산서
            </Parking5_Btn>
            <Parking5_Btn
              onClick={() => {
                set_Parking5_Type("절감계산서");
              }}
              $select={parking5_type === "절감계산서"}
            >
              절감계산서
            </Parking5_Btn>
            <Parking5_Btn
              onClick={() => {
                set_Parking5_Type("사진대지");
              }}
              $select={parking5_type === "사진대지"}
            >
              사진대지
            </Parking5_Btn>
          </Parking5_div>
          {parking5_type === "공사원가계산서" ? (
            <>
              <Image_div2>
                <Image3 src={image_parking_5_1_1} alt={image_parking_5_1_1} />
              </Image_div2>
              <Image_div2>
                <Image3 src={image_parking_5_1_2} alt={image_parking_5_1_2} />
              </Image_div2>
              <Image_div2>
                <Image3 src={image_parking_5_1_3} alt={image_parking_5_1_3} />
              </Image_div2>
              <Text_div2>
                <Content_Text $large $bold>
                  공사원가계산서
                </Content_Text>
                <Content_Text $gray>
                  공사원가계산서 작성에 필요한 정보들을 입력하고 관리할 수
                  있습니다.
                </Content_Text>
              </Text_div2>
            </>
          ) : parking5_type === "절감계산서" ? (
            <>
              <Image_div2>
                <Image3 src={image_parking_5_2_1} alt={image_parking_5_2_1} />
              </Image_div2>
              <Image_div2>
                <Image3 src={image_parking_5_2_2} alt={image_parking_5_2_2} />
              </Image_div2>
              <Image_div2>
                <Image3 src={image_parking_5_2_3} alt={image_parking_5_2_3} />
              </Image_div2>
              <Image_div2>
                <Image3 src={image_parking_5_2_4} alt={image_parking_5_2_4} />
              </Image_div2>
              <Text_div2>
                <Content_Text $large $bold>
                  절감계산서
                </Content_Text>
                <Content_Text $gray>
                  절감계산서에 필요한 정보들을 입력하고 관리할 수 있습니다.
                </Content_Text>
              </Text_div2>
            </>
          ) : (
            <>
              <Image_div2>
                <Image3 src={image_parking_5_3_1} alt={image_parking_5_3_1} />
              </Image_div2>
              <Image_div2>
                <Image3 src={image_parking_5_3_2} alt={image_parking_5_3_2} />
              </Image_div2>
              <Image_div2>
                <Image3 src={image_parking_5_3_3} alt={image_parking_5_3_3} />
              </Image_div2>
              <Text_div2>
                <Content_Text $large $bold>
                  사진대지
                </Content_Text>
                <Content_Text $gray>
                  공사의 검수사진들을 등록하고 관리할 수 있습니다.
                </Content_Text>
              </Text_div2>
            </>
          )}
        </>
      ) : (
        <>
          <Image_div2>
            <Image3 $large src={image_parking_6} alt={image_parking_6} />
          </Image_div2>
          <Text_div2>
            <Content_Text $gray>
              일정을 분류하고 등록 및 관리할 수 있습니다.
            </Content_Text>
          </Text_div2>
        </>
      )}
    </>
  );
};

export default Platform_FMS_주차시설;
